export default __webpack_public_path__ + "static/media/Touch Panel.292cbb86.pdf";